export { default as EmailInput } from './email-input';
export { default as LoginPasswordInput } from './login-password-input';
export { default as LoyaltyIdInput } from './loyalty-id-input';
export { default as NameInput } from './name-input';
export { default as RegisterPasswordInput } from './register-password-input';
export { default as SubscriberInput } from './subscriber-input';
export {
    default as TermsAndConditionsInput,
} from './terms-and-conditions-input';
export { default as LoyaltyOptIn } from './loyalty-opt-in'
